// Horizon shows the inline nav menu on desktop and only collapses to a hamburger
// drawer on touch devices or when the menu overflows. This store always wants the
// hamburger drawer, at every screen size, so we pin the header's menu-style attribute.
function forceDrawerMenu() {
  const headerComponent = document.querySelector('#header-component');
  if (headerComponent) {
    headerComponent.dataset.menuStyle = 'drawer';
  }
}

forceDrawerMenu();
window.addEventListener('resize', forceDrawerMenu);
